import { AccessorsMutatorsDecorator, Model } from '../../helpers';

/**
 * @class HouseAccountTransaction
 *
 * @property {number} id
 * @property {number} type
 * @property notes
 * @property quantity
 * @property debit
 * @property credit
 * @property created_at
 * @property subject
 * @property subject_type
 * @property is_refund
 * @property is_void
 * @property item
 * @property description
 * @property is_deleted
 * @property username
 * @property transaction_code
 * @property created_at_tz
 * @property {number} voucher_id
 * @property {string} voucher_ident
 */
export class HouseAccountTransaction extends Model {

    static get PAYMENT_TYPE() {
        return 1;
    }

}

AccessorsMutatorsDecorator(
    'id',
    'type',
    'notes',
    'quantity',
    'debit',
    'credit',
    'created_at',
    'subject',
    'subject_type',
    'is_refund',
    'is_void',
    'item',
    'description',
    'is_deleted',
    'username',
    'transaction_code',
    'created_at_tz',
    'voucher_id',
    'voucher_ident',
    'voucher_type',
)(HouseAccountTransaction);



// WEBPACK FOOTER //
// ./src/pms-api/models/house-account-transaction.model.js